export default "__VITE_ASSET__B8bwM_x8__"